import AbstractSmsTemplatesEditorPageCtrl from "./abstract-editor";

export default class SmsTemplatesEditPageCtrl extends AbstractSmsTemplatesEditorPageCtrl {

    constructor($scope, $injector) {
        super($scope, $injector)
        this.headline = this.translate.instant(`messages.controllers.pages.sms.templates.edit.title`)

        this.loadEntryToEdit()
    }

    async loadEntryToEdit() {
        const response = await this.api.get(`messages/sms/templates/${this.stateParams.id}`)

        this.model = response.data.data
    }

    async handleSubmitData() {
        return this.api.put(`messages/sms/templates/${this.stateParams.id}`, this.model)
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/pages/sms/templates/edit.js